import React, { useEffect } from 'react'
import Modal from 'antd/es/modal'
import Form from 'antd/es/form'
import Input from 'antd/es/input'
import Button from 'components/button'
import { CreateCustomerVariables } from 'models/customer'
import Notification from 'antd/es/notification'
import Select from 'antd/es/select'

type Props = {
  visible: boolean
  onSave: (customer: CreateCustomerVariables) => void
  onCancel: () => void
}

export const AddNewCustomer = (props: Props) => {
  const [form] = Form.useForm()

  const onFinish = (result: CreateCustomerVariables) => {
    try {
      const validate = new CreateCustomerVariables(result)
      props.onSave(validate)
    } catch (e) {
      console.log(e)
      Notification.error({ message: JSON.stringify(e) })
    }
  }

  useEffect(() => {
    form.resetFields()
  }, [props.visible])

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Modal
      visible={props.visible}
      title={'Lisää ' + global.Translations.get('customer')}
      onCancel={() => {
        props.onCancel()
      }}
      closable={false}
      closeIcon={false}
      style={{ maxWidth: '400px' }}
      footer={
        <Button.ButtonGroup style={{ justifyContent: 'flex-end' }}>
          <Button
            label="Peruuta"
            onClick={() => {
              props.onCancel()
            }}
            color="default"
          />
          <Button
            label="Tallenna"
            onClick={() => {
              form.submit()
            }}
            color="green"
          />
        </Button.ButtonGroup>
      }
    >
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        {/* Customer */}
        <Form.Item label={'Nimi'} name="name" rules={[{ required: true, message: 'Anna asiakkaalle nimi' }]}>
          <Input />
        </Form.Item>
        {/* Business city */}
        <Form.Item
          initialValue={'pori'}
          name="city"
          label="Kaupunki"
          rules={[
            {
              message: 'Anna kaupunki',
              required: true
            }
          ]}
        >
          <Select placeholder="Kaupunki">
            <Select.Option value={'espoo'}>Espoo</Select.Option>
            <Select.Option value={'pori'}>Pori</Select.Option>
            <Select.Option value={'turku'}>Turku</Select.Option>
          </Select>
        </Form.Item>
        {/* Business Indentification Number */}
        <Form.Item
          label="Y-Tunnus"
          name="business_identity_code"
          hidden={true}
          rules={[{ required: false, message: 'Anna Y-Tunnus!' }]}
        >
          <Input />
        </Form.Item>
        {/* Contacts */}
        <Form.Item hidden={true} initialValue={[]} label="Yhteyshenkilöt" name="contacts">
          <Input />
        </Form.Item>
        {/* Employees */}
        <Form.Item hidden={true} initialValue={[]} label={global.Translations.get('employees')} name="employees">
          <Input />
        </Form.Item>
        {/* Assignments */}
        <Form.Item hidden={true} initialValue={[]} label={'Toimeksiannot'} name="assignments">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default AddNewCustomer
